import React from "react";
import BaseFormPage from "../../../base/BaseFormPage";
import FormFactory from "../../../components/FormFactory";
import withRouter from "../../../withRouter";
import SettingsFormPresenter from "./SettingsFormPresenter";
import systemSettingsSchema from "./systemSettingsSchema";

class SettingsFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.presenter = new SettingsFormPresenter(this);
  }

  getCollectionName() {
    return "systemSettings";
  }

  getObjectId() {
    return undefined;
  }

  render() {
    const { object } = this.state;
    return (
      <>
        <form
          className="d-flex flex-column gap-4 p-3 p-md-4"
          onSubmit={this.onSubmitForm.bind(this)}
        >
          <FormFactory
            schema={systemSettingsSchema}
            object={object}
            onChange={this.onChange.bind(this)}
            className="col-12 col-md-6"
          />

          <div className="d-flex gap-2 mt-2 pt-2 border-top justify-content-end">
            {!this.props.embedded && (
              <button
                type="button"
                className="btn btn-light fw-medium border px-3"
                onClick={this.onClickBack.bind(this)}
              >
                Cancel
              </button>
            )}
            <button
              type="submit"
              className="btn btn-primary fw-medium px-3"
              disabled={this.state.submitting}
            >
              {this.state.submitting ? "Saving…" : "Save settings"}
            </button>
          </div>
        </form>
        {this.renderPreviewModal()}
      </>
    );
  }
}

export default withRouter(SettingsFormPage);
